import React from 'react'
import DonationModal from '../components/Modals/DonationModal'

const Donate = () => {
    return (
        <DonationModal/>
    )
}

export default Donate
